import { render, staticRenderFns } from "./LeftCard2.vue?vue&type=template&id=3d5f8ceb&scoped=true&"
import script from "./LeftCard2.vue?vue&type=script&lang=js&"
export * from "./LeftCard2.vue?vue&type=script&lang=js&"
import style0 from "./LeftCard2.vue?vue&type=style&index=0&id=3d5f8ceb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5f8ceb",
  null
  
)

export default component.exports